var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConsumerExp = function SvgConsumerExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 86,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer-exp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#consumer-exp_svg__b)",
    d: "M37.376 34.092V8.045c0-2.326-2.979-3.292-4.344-1.408L2.759 48.42c-1.15 1.587-.016 3.808 1.944 3.808H26.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#consumer-exp_svg__c)",
    d: "M26.59 52.227v26.022c0 2.326 2.977 3.292 4.343 1.41L61.236 37.9c1.15-1.586.017-3.81-1.943-3.81H37.375z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "consumer-exp_svg__b",
    x1: -15.588,
    x2: 49.991,
    y1: -18.702,
    y2: 28.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "consumer-exp_svg__c",
    x1: 10.988,
    x2: 76.557,
    y1: 14.76,
    y2: 62.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer-exp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .642h64v85H0z"
  })))));
};
export { SvgConsumerExp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA2NCA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5Nl8zOTcxKSI+CjxwYXRoIGQ9Ik0zNy4zNzU1IDM0LjA5MTdWOC4wNDUzM0MzNy4zNzU1IDUuNzE4OCAzNC4zOTcgNC43NTMxOSAzMy4wMzIgNi42MzcxOEwyLjc1OTE5IDQ4LjQxODdDMS42MDk0OCA1MC4wMDU1IDIuNzQzMTUgNTIuMjI2OCA0LjcwMjY4IDUyLjIyNjhIMjYuNTkwOEwzNy4zNzU1IDM0LjA5MTdaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzk2XzM5NzEpIi8+CjxwYXRoIGQ9Ik0yNi41OTA4IDUyLjIyN1Y3OC4yNDkxQzI2LjU5MDggODAuNTc0NyAyOS41Njc0IDgxLjU0MDkgMzAuOTMzMyA3OS42NTg3TDYxLjIzNTUgMzcuOTAxNUM2Mi4zODY4IDM2LjMxNDkgNjEuMjUzNCAzNC4wOTE5IDU5LjI5MyAzNC4wOTE5SDM3LjM3NTRMMjYuNTkwOCA1Mi4yMjdaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfMzk2XzM5NzEpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zOTZfMzk3MSIgeDE9Ii0xNS41ODg1IiB5MT0iLTE4LjcwMTciIHgyPSI0OS45OTExIiB5Mj0iMjguODE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM1QkE0RUEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTQ0OTdCIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8zOTZfMzk3MSIgeDE9IjEwLjk4ODIiIHkxPSIxNC43NjA0IiB4Mj0iNzYuNTU2OCIgeTI9IjYyLjM0MTkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzVCQTRFQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxNDQ5N0IiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zOTZfMzk3MSI+CjxyZWN0IHdpZHRoPSI2NCIgaGVpZ2h0PSI4NSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC42NDI0NTYpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";